import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAuthStore } from '../store.js';
import { api } from '../api.js';
import { Card, CardHeader, Button, Input, PageHeader } from '../components/ui.jsx';

export default function SettingsPage() {
  const { company, loadMe } = useAuthStore();
  const [name, setName] = useState(company?.name || '');
  const [primaryColor, setPrimaryColor] = useState(company?.primary_color || '#1E40AF');

  const update = useMutation({
    mutationFn: (body) => api.updateMyCompany(body),
    onSuccess: loadMe
  });

  return (
    <>
      <PageHeader title="Settings" description="Workspace preferences, branding, and security." />

      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <CardHeader title="Workspace" />
          <form onSubmit={(e) => { e.preventDefault(); update.mutate({ name }); }} className="space-y-4">
            <Input label="Company name" value={name} onChange={e => setName(e.target.value)} />
            <Button type="submit" loading={update.isPending}>Save</Button>
          </form>
        </Card>

        <Card>
          <CardHeader title="Brand" subtitle="Colours used in dashboards and email templates" />
          <div className="space-y-4">
            <Input label="Primary color (hex)" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} placeholder="#1E40AF" />
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg" style={{ background: primaryColor }} />
              <span className="text-xs text-ink-500">Preview</span>
            </div>
          </div>
        </Card>

        <Card className="md:col-span-2">
          <CardHeader title="Security" subtitle="2FA, SSO, and session controls" />
          <p className="text-sm text-ink-500">SSO / SAML configuration interface coming soon. Contact support@skillbase.com.au to enable enterprise SSO with Okta, Azure AD, or Google Workspace.</p>
        </Card>
      </div>
    </>
  );
}
